import Core from 'core/js/pages/municipality/index.js'

// @vue/component
export default Vue.extend({
  extends: Core,
  name: 'municipality-page-custom-rd',
  computed: {
    items(){
      let items = [
        // CORE: estarán siempre en todas las ciudades.
        {
          value: HOME_ROUTE,
          icon: 'inicio',
          label: this.$t('defaultLayout.options.home')
        },
        {
          value: 'municipality-routes',
          icon: 'lineas',
          label: this.$t('defaultLayout.options.routes')
        },
        {
          value: 'municipality-stops',
          icon: 'paradas',
          label: this.$t('defaultLayout.options.stops')
        },
        {
          value: 'municipality-point-of-sales',
          icon: 'ventas',
          label: this.$t('defaultLayout.options.sales')
        },
        /** Personalización: Amarante, Vizur */
        {
          value: 'municipality-news',
          icon: 'news',
          label: this.$t('defaultLayout.options.news')
        },
        {
          value: 'municipality-pre-purchase-fares',
          icon: 'tarifas',
          label: this.$t('defaultLayout.options.prePurchaseFares')
        },
        {
          value: 'municipality-schedules',
          icon: 'horarios',
          label: this.$t('defaultLayout.options.schedules')
        },
        /** Personalización: Amarante */
        {
          value: 'renting',
          icon: 'rent',
          label: this.$t('defaultLayout.options.renting')
        }
      ]

      /** Only if QR enabled in backend */
      if (this.administrativeArea.enable_abt_account) {
        items.push({
          value: 'municipality-recharge',
          icon: 'recargar',
          label: this.$t('defaultLayout.options.recharge'),
        })
      }

      // Push item if the 'Planner with map' option is active in the admin.
      if (this.administrativeArea.config.planner_with_map) {
         items.push({
          value: 'municipality-planner',
          icon: 'planner-vz',
          label: this.$t('defaultLayout.options.planner')
        })
      }

      return items;
/*
        {
          value: 'municipality-movements-history',
          icon: 'movements', // @todo: Cambiar a history
          label: this.$t('defaultLayout.options.movementsHistory')
        },
        {
          value: 'municipality-advertising',
          icon: 'publicidad',
          label: this.$t('defaultLayout.options.advertising')
        },
        {
          value: 'municipality-network-map',
          icon: 'mapa',
          label: this.$t('defaultLayout.options.networkMap')
        },
        {
          value: 'municipality-vamus-experiences',
          icon: 'experiencias',
          label: this.$t('defaultLayout.options.vamusExperiencesLowerCase')
        }
*/
    }
  }
})
